import { GetterTree } from "vuex";
import { AuthenticationState, CurrentUser, JwtConfigs, RoleEnum } from "./types";
import { RootState } from "@/store/types";

export const getters: GetterTree<AuthenticationState, RootState> = {
    isLoggedIn(state): boolean {
        return Boolean(state.token);
    },
    getCurrentUser(state): CurrentUser {
        return state.currentUser;
    },
    getToken(state): string {
        return state.token;
    },
    authorize(state) {
        return (param: RoleEnum) => {
            if (!param) {
                return false;
            }
            if (param === RoleEnum.Any) {
                return true;
            }
            return state.currentUser.roles.some(function (role) {
                return role.toLowerCase() === param.toString().toLowerCase();
            });
        };
    },
    getJwtConfigs(state): JwtConfigs {
        return state.jwtConfigs;
    },
    getAutoLogout(state): boolean {
        return state.autoLogout;
    }
};
